





import {
  Vue,
  Component,
  Prop,
  Provide,
  Emit,
  Watch,
  Inject,
} from "vue-property-decorator";

@Component({
  components: {},
})

export default class ButtonGroup extends Vue {
    @Prop() 
    public param! : Array<any>;
    @Prop() 
    public groupName? : String;
    @Prop()
    public defaultActive!: String;

    public listData: Array<any> = [];
    
    public handleClick(value:any) {
       this.activeKey(value.key)
       this.$emit("buttonClick",{groupName:this.groupName,key:value.key})
    }

    public activeKey(key:String) {
        const temp = [...this.param];
        temp.forEach((value : any) => {
            if(value.key == key) {
                value.isActive  = true;
            } else {
                value.isActive = false;
            }
        })
        this.$emit("update:param",temp)
    }
}
